:host {
  display: block;
}

ul {
  margin: 6px 0px;
  padding: 0px;
  list-style: none;
}
